const ar = {
	logo:'BOOKLUAR' ,
	searchPlaceholder:'ابحث عن كتاب, مؤلف, او دار نشر',
	bestSeller : "الاكثر مبعيا",
	classicNovels: " رويات كلاسكية",
	History : "تاريخ",
	title: "العنوان",
	author: "الكاتب",
	publisher: "الناشر" ,
	publishedDate: "تاريخ النشر",
	read: "قراء",
	speakNow: "تحدث الان ",
	technology:"تكنولوجيا",
	philosophy:"فلسفة" ,
	ReligiousBooks: "كتب دنية",
	Fiction:"خيال علمي",
	categories: "التصنيفات",
	more:"المذيد"



};

export default ar;